<section class="admin-conversation-page">
  <div class="conversation-head">
    <div>
      <span class="admin-badge">تفاصيل شات الشحات إن</span>
      <h1>محادثة #{{ conversationId }}</h1>
      <p>راجع الرسائل، تابع حالة العميل، ورد عليه بنفس أسلوب تجربة الشات في الموقع.</p>
    </div>

    <button type="button" class="back-btn" (click)="backToChats()">
      رجوع لكل المحادثات
    </button>
  </div>

  <div class="admin-state" *ngIf="isLoading">جاري تحميل المحادثة...</div>

  <div class="admin-state error" *ngIf="!isLoading && errorMessage">
    {{ errorMessage }}
  </div>

  <div class="conversation-layout" *ngIf="!isLoading && conversation">
    <aside class="customer-card">
      <div class="customer-avatar">
        {{ getUserDisplayName().charAt(0) }}
      </div>

      <h2>{{ getUserDisplayName() }}</h2>

      <span
        class="status-badge"
        [class.open]="conversation.status === 'open'"
        [class.pending]="conversation.status === 'pending'"
        [class.closed]="conversation.status === 'closed'"
      >
        {{ getStatusLabel(conversation.status) }}
      </span>

      <div class="info-list">
        <div>
          <span>نوع المستخدم</span>
          <strong>{{ getUserTypeLabel(conversation.user_type) }}</strong>
        </div>

        <div>
          <span>الهاتف</span>
          <strong>{{ conversation.phone || '-' }}</strong>
        </div>

        <div>
          <span>الإيميل</span>
          <strong>{{ conversation.email || '-' }}</strong>
        </div>

        <div>
          <span>واتساب</span>
          <strong>{{ conversation.whatsapp_number || '-' }}</strong>
        </div>

        <div>
          <span>المصدر</span>
          <strong>{{ conversation.source_page || '-' }}</strong>
        </div>

        <div>
          <span>جلسة الزائر</span>
          <strong>{{ conversation.session_id || '-' }}</strong>
        </div>

        <div>
          <span>آخر رسالة</span>
          <strong>{{ formatDate(conversation.last_message_at) }}</strong>
        </div>
      </div>

      <label class="status-control">
        <span>تغيير الحالة</span>
        <select
          [value]="conversation.status"
          (change)="updateStatus($event)"
          [disabled]="isUpdating"
        >
          <option value="open">مفتوح</option>
          <option value="pending">قيد المتابعة</option>
          <option value="closed">مغلق</option>
        </select>
      </label>
    </aside>

    <main class="chat-panel">
      <div class="chat-panel-head">
        <div>
          <h2>الرسائل</h2>
          <p>{{ messages.length }} رسالة</p>
        </div>

        <button type="button" class="refresh-btn" (click)="loadConversation(true)">
          تحديث يدوي
        </button>
      </div>

      <div class="messages-box" #messagesBox>
        <div
          class="chat-row"
          *ngFor="let message of messages"
          [class.user-row]="message.sender_type === 'user'"
          [class.admin-row]="message.sender_type === 'admin'"
          [class.bot-row]="message.sender_type !== 'user' && message.sender_type !== 'admin'"
        >
          <div class="message-bubble">
            <strong>{{ getSenderLabel(message.sender_type) }}</strong>
            <p>{{ getMessageText(message) }}</p>
            <small>{{ message.time || formatDate(message.created_at) }}</small>
          </div>
        </div>

        <div class="admin-state" *ngIf="!messages.length">
          لا توجد رسائل ظاهرة حتى الآن.
        </div>
      </div>

      <div class="reply-box">
        <textarea
          placeholder="اكتب رد الأدمن هنا..."
          [value]="replyMessage"
          (input)="replyMessage = $any($event.target).value"
          (keydown.enter.ctrl)="sendAdminReply()"
          [disabled]="isSending"
        ></textarea>

        <button
          type="button"
          class="send-btn"
          (click)="sendAdminReply()"
          [disabled]="!replyMessage.trim() || isSending"
        >
          {{ isSending ? 'جاري الإرسال...' : 'إرسال الرد' }}
        </button>
      </div>
    </main>
  </div>
</section>
